import { ReactElement } from 'react';
import { IMeta } from '@/common/domain/Meta.domain';
import { CommonMeta } from '@/common/ui/meta/CommonMeta';
import { buildRootUrl } from '@/common/app/utils/urlsUtils';

type ActivityPageProps = {
    pageMeta?: IMeta;
    metaRow: string;
    pageActivity?: {
        rate_count: string;
        name: string;
        url: string;
    };
    pageStructuredData: string;
    img: string;
};

const ReviewMeta = ({
    pageMeta,
    metaRow,
    pageActivity,
    pageStructuredData,
    img,
}: ActivityPageProps): ReactElement => {
    const canonical = buildRootUrl(pageActivity?.url.split('?')[0] + 'reviews/');
    return (
        <CommonMeta
            title={`Traveler Reviews of ${metaRow} - TripShock!`}
            description={
                (pageMeta && pageMeta.description) ||
                `Find ${pageActivity?.rate_count} Verified Traveler Reviews for ${metaRow} on TripShock. View tour photos, info, availability, & Book Online.`
            }
            canonical={canonical}
            structuredData={[pageStructuredData]}
            imageSrc={img}
            slug={''}
            ogUrl={canonical}
        />
    );
};

export { ReviewMeta };
export default ReviewMeta;
